import { render, staticRenderFns } from "./associationKnowledge.vue?vue&type=template&id=6400b957&scoped=true"
import script from "./associationKnowledge.vue?vue&type=script&lang=js"
export * from "./associationKnowledge.vue?vue&type=script&lang=js"
import style0 from "./associationKnowledge.vue?vue&type=style&index=0&id=6400b957&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400b957",
  null
  
)

export default component.exports